export default function (item) {

    let excerto = {}
    excerto.excertoId = item ? item.excertoId : null
    excerto.subtema = item?item.subtema : {subtemaId:"", nome:"", temaDTO:{nome:"",temaId:""}}
    excerto.processo = item ? item.processo : {
        processoId: "",
        exercicio: "",
        ano: "",
        cdProcesso: "",
        especie: "",
        natureza: "",
        relator: "",
        unidade: "",
        responsavel: ""
    },
    excerto.cdProcesso = item ? item.cdProcesso : ""
    excerto.cdAno = item ? item.cdAno : ""
    excerto.DataInclusao = item ? item.DataInclusao : ""
    excerto.texto = item ? item.texto : null
    excerto.observacao = item ? item.observacao : ""

    /* let processo = {
        processoId: "",
        exercicio: "",
        ano: "",
        cdProcesso: "",
        especie: "",
        natureza: "",
        relator: "",
        unidade: "",
        responsavel: ""
    } */

    return excerto
}